import { faker } from '@faker-js/faker';

type RealWorkHistory = {
  companyName: string;
  roleTitle: string;
  duration?: string;
};

const DEFAULT_SEED = 12345;
const DEFAULT_COUNT = 2;
export const generateFakeWorkHistories = (
  realWorkHistory?: RealWorkHistory,
  count?: number,
) => {
  const fakerSeed = realWorkHistory
    ? asciiConvert(realWorkHistory.companyName) +
      asciiConvert(realWorkHistory.roleTitle)
    : DEFAULT_SEED;

  faker.seed(fakerSeed);

  const fakeWorkHistories = Array.from({ length: count ?? DEFAULT_COUNT }).map(
    (_, index) => ({
      companyName:
        realWorkHistory && index === 0
          ? realWorkHistory.companyName
          : faker.company.name(),
      roleTitle:
        realWorkHistory && index === 0
          ? realWorkHistory.roleTitle
          : faker.person.jobTitle(),
      duration: randomDuration(),
    }),
  );

  return fakeWorkHistories;
};

export const asciiConvert = (str: string): number =>
  str.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);

const randomDuration = () => {
  const durationFormat = ['months', 'years', 'months and years'];
  const value = faker.number.int({ min: 1, max: 10 });
  const format = faker.helpers.arrayElement(durationFormat);
  const fakeStartDate = `${faker.date.month({ abbreviated: true })} ${faker.number.int(
    {
      min: 1990,
      max: new Date().getFullYear(),
    },
  )}`;

  const fakeEndDate = `${faker.date.month({ abbreviated: true })} ${faker.number.int(
    {
      min: 1990,
      max: new Date().getFullYear(),
    },
  )}`;

  const durationText = {
    months: `${value} months`,
    years: `${value} years`,
    'months and years': `${value} years ${faker.number.int({ min: 1, max: 11 })} months`,
  }[format];

  return `${fakeStartDate} - ${fakeEndDate} (${durationText})`;
};
